import React, { useState, useEffect } from 'react';
import { Container, Image, Table } from 'react-bootstrap';
import {
  findObservatorioVial,
  listDocumentoMovimientoTerminalSitioWeb,
  listDocumentoInformeEstadisticoSitioWeb,
  listSliderByGallerySitioWeb,
} from '@/api/municipalidadAPI';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { URL_ADJUNTOS } from '../constants/constants';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './ObservatorioView.css';

const ObservatorioView = () => {
  const [observatorio, setObservatorio] = useState(null);
  const [movimientosTerminal, setMovimientosTerminal] = useState(null);
  const [informesEstadisticos, setInformesEstadisticos] = useState(null);
  const [galeria, setGaleria] = useState(null);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    findObservatorioVial()
      .then((response) => {
        setObservatorio(response.data);
        setLogo(URL_ADJUNTOS + '?id=' + response.data.logo.id);

        listSliderByGallerySitioWeb(response.data.galeria.nombre)
          .then((response) => {
            buildGaleryImages(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });

    listDocumentoMovimientoTerminalSitioWeb()
      .then((response) => {
        setMovimientosTerminal(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    listDocumentoInformeEstadisticoSitioWeb()
      .then((response) => {
        setInformesEstadisticos(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function buildGaleryImages(items) {
    let images = [];
    for (let i = 0; i < items.length; i++) {
      let url = URL_ADJUNTOS + '?id=' + items[i].imagen.id;
      images.push({
        original: url,
        thumbnail: url,
      });
    }
    setGaleria(images);
  }

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Observatorio Vial"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <Image className="logo-observatorio" src={logo}></Image>
        {observatorio != null && (
          <div dangerouslySetInnerHTML={{ __html: observatorio.texto }}></div>
        )}
        <h5>Movimiento de personas en terminal terrestre de Villa La Angostura</h5>
        {movimientosTerminal !== null && (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Año</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              {movimientosTerminal !== null &&
                movimientosTerminal.length > 0 &&
                movimientosTerminal.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.mesAsString + ' ' + item.anioDocumentoAsString}</td>
                    <td>
                      <a
                        href={URL_ADJUNTOS + '?id=' + item.documento.id}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Descargar
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
        <h5>Informes Estadísticos OSSIVI</h5>
        {informesEstadisticos !== null && (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Año</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              {informesEstadisticos !== null &&
                informesEstadisticos.length > 0 &&
                informesEstadisticos.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.anioDocumentoAsString}</td>
                    <td>
                      <a
                        href={URL_ADJUNTOS + '?id=' + item.documento.id}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Descargar
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
        <h5>Galería de imágenes de Observatorio Vial</h5>
        {galeria != null && <ImageGallery items={galeria} thumbnailPosition="left" />}
      </Container>
    </>
  );
};

export default React.memo(ObservatorioView);
